import { FilterModel } from '@models/module/grid/filterModel';
import { SortModel } from '@models/module/grid/sortModel';

export interface SearchPagedList {
  page?: number;
  pagesize?: number;
}

export interface SearchViewModel extends SearchPagedList {
  id?: number;
  criteria?: string;
  filter?: FilterModel;
  sort?: SortModel[];
  isCurrent?: boolean;
  showDisabled?: boolean;
  showPresets?: boolean;
}
